import React from 'react'
import {Icon} from '@therms/atalaya'
import {MobileMenuLink} from '@src/modules/Layout/shared/MobileMenuLink'
import {STATS_ROUTES} from '../../constants'
import {MdAreaChart} from 'react-icons/md'

function StatsMobileMenuLink() {
  return (
    <MobileMenuLink to={STATS_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={MdAreaChart} />
        <span>Stats</span>
      </div>
    </MobileMenuLink>
  )
}

export {StatsMobileMenuLink}
